import type { ReactNode } from 'react'

import { Chip } from '@/components/ui/Chip'
import { PlatformChip, type Platform } from './PlatformChip'
import styles from './PlatformCard.module.scss'

export interface PlatformCardProps {
  platform: Platform
  /** "principal" (decide o que sai) ou "destino" (espelha a principal). */
  kind: 'principal' | 'destino'
  /** O chip de estado da conexão. */
  status: ReactNode
  /** Linha de dados da conta (@, tipo, expiração). */
  details?: ReactNode
  /** Botões à direita (Conectar, Reconectar, Desconectar). */
  actions?: ReactNode
  /** Avisos e notas sob a linha principal. */
  children?: ReactNode
}

/** Um cartão por plataforma na seção "Plataformas" da tela do canal. */
export function PlatformCard({ platform, kind, status, details, actions, children }: PlatformCardProps) {
  return (
    <div className={styles.card} data-platform={platform}>
      <div className={styles.head}>
        <PlatformChip platform={platform} size="md" />
        <Chip>{kind}</Chip>
        {status}
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
      {details ? <div className={styles.details}>{details}</div> : null}
      {children ? <div className={styles.notes}>{children}</div> : null}
    </div>
  )
}

/** Um par "rótulo: valor" da linha de dados do cartão. */
export function PlatformDetail({ label, children }: { label: string; children: ReactNode }) {
  return (
    <span className={styles.detail}>
      <span className={styles.detailLabel}>{label}</span>
      <span className={styles.detailValue}>{children}</span>
    </span>
  )
}
